import React, { createContext } from 'react';

import useAuth from './hooks/useAuth';

const Context = createContext(undefined);

function AuthProvider({ children }) {
    const { authenticated, loading, handleLogin, handleLogout, showingSessionExperiedModal, setShowingSessionExperiedModal, userInfo
      , handleUserInfo,setLoading,deleteInfoInLocalStorage, isAuthenticated, addAlert, alertsList, setAlertsList} = useAuth();

    return (
        <Context.Provider value={{ loading, authenticated, handleLogin,
          handleLogout, showingSessionExperiedModal, setShowingSessionExperiedModal,
          userInfo, handleUserInfo, setLoading,deleteInfoInLocalStorage, isAuthenticated, addAlert, alertsList, setAlertsList}}>
            {children}
        </Context.Provider>
    );
}

export { Context, AuthProvider };
